import React from "react";
import btcSrc from "../assets/home-img.jpg";
import { Box, Image, Text } from "@chakra-ui/react";
const Home = () => {
  return (
    <Box bgColor={"blackAlpha.900"} w={"full"} h={"75vh"}>
      <Image w={"full"} h={"full"} objectFit={"contain"} src={btcSrc} />
    </Box>
  );
};

export default Home;
